import React from "react";
import ControlPanel from "./ControlPanel";
import useControlAttribute from "../../hooks/useControlAttribute";
import useModeColor, { TMode } from "../../hooks/useModeColor";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IControlMieleDevice, TMieleDeviceStatus } from "./types";
import { useTranslation } from "react-i18next";

interface IControlMieleDeviceProps {
  control: IControlMieleDevice;
}

const ControlMieleDevice = (props: IControlMieleDeviceProps) => {
  const { control } = props;
  const deviceStatus: TMieleDeviceStatus = useControlAttribute(
    control,
    "status"
  );
  const remainingTime = useControlAttribute(control, "remaining_time");
  const startTime = useControlAttribute(control, "start_time");
  const mode: TMode = control.is_enabled
    ? deviceStatus === null || deviceStatus === "Off"
      ? "off"
      : "on"
    : "disabled";
  const iconColor = useModeColor(mode);
  const { t } = useTranslation();

  const state = () => {
    if (deviceStatus === "Waiting to start") {
      return t("start in WHAT", { what: startTime });
    }
    if (deviceStatus === "In use") {
      return t("done in WHAT", { what: remainingTime });
    }
    return "";
  };

  return (
    <ControlPanel
      id={control.id}
      mode={mode}
      title={control.name}
      state={state()}
    >
      <ToggleIconLink
        to={`/controls/details/${control.id}`}
        name={"washing-machine"}
        color={iconColor}
      />
    </ControlPanel>
  );
};

export default ControlMieleDevice;
